var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-tooltip",
    {
      attrs: {
        effect: "dark",
        "popper-class": "licence-product-tooltip",
        manual: !_vm.disabledQuantity,
        placement: "bottom-start"
      },
      model: {
        value: _vm.showTooltip,
        callback: function($$v) {
          _vm.showTooltip = $$v
        },
        expression: "showTooltip"
      }
    },
    [
      _c("span", {
        attrs: { slot: "content" },
        domProps: { innerHTML: _vm._s(_vm.tooltipLabel) },
        slot: "content"
      }),
      _vm._v(" "),
      _c("el-input-number", {
        ref: "licenceProduct",
        staticClass: "licence-product-quantity",
        class: { "licence-deleted": _vm.licencesBeDeleted },
        attrs: {
          "step-strictly": "",
          disabled: _vm.disabledQuantity,
          value: _vm.quantityProduct,
          min: _vm.minQuantity
        },
        on: {
          change: function(val) {
            return _vm.$emit("update", val)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }